export default "__VITE_ASSET__BnEioYZe__"